import { connectedComponent } from 'utils/redux/providerWrapper';
import { NavigationBarWrapper } from './navigation_bar';

export const ConnectedNavigationBar = connectedComponent(NavigationBarWrapper);

export default ConnectedNavigationBar;
